<template>
  <div class="no-service-message">
   No data available.
  </div>
</template>

<script>
export default {
  name: 'NoService',
}
</script>

<style scoped>
.no-service-message {
  font-size: 1.0rem;
  color: #b71c1c;
  text-align: center;
  margin-top: 2rem;
}
</style>
